
























// STOP. DO NOT TOUCH THIS. BACK AWAY. THIS WAY MADNESS LIES
// for some reason, the import and register of the document list isn't working HERE. It works EVERYWHERE ELSE. Just not HERE
// so, I followed https://stackoverflow.com/a/58875919/11569, which is really for recursive components, which we don't have (I don't think?)
// but it works. So I'm backing all the way away from this madness and just importing it like this.
// import OtDocumentList from '@/components/documents/document-list/ot-document-list.vue';
import OtDocumentsFilter from '@/components/documents/document-list/ot-documents-filter.vue';
import { DocumentListLevel, DocumentListMode, DocumentsFilter } from '@/components/documents/document-models';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    // OtDocumentList,
    OtDocumentList: () => import('@/components/documents/document-list/ot-document-list.vue'),
    OtDocumentsFilter,
  },
})
export default class OtSettingsDocumentsIndex extends Vue {
  // * PROPS
  @Prop({ default: '' }) private orgGid!: string;

  // * REFS

  // * DATA
  private filters: DocumentsFilter | null = null;
  private level = DocumentListLevel.Organisation;
  private mode = DocumentListMode.Display;
  private get locationDescription() {
    return 'Organisation';
  }

  // * METHODS
  private handleFilterUpdate(nextFilter: DocumentsFilter) {
    this.filters = nextFilter;
  }

  // * LIFECYCLE
}
